import { Component, Input, OnInit, inject, input } from '@angular/core';
import { TabViewModule } from 'primeng/tabview';
import { CoreApiService } from '../../../../core/service/core-api-service';
import { AppService } from '../../../../core/service/app.service';
import { JsonRequest } from '../../../../model/jsonRequest.model';
import { properties } from '../../../../../environments/properties';
import { DriverModel } from '../../../../model/driver.model';
import { DataViewModule } from 'primeng/dataview';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { DocumentDriverModel } from '../../../../model/document.driver.model';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { TableModule } from 'primeng/table';
import { ImageModule } from 'primeng/image';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentDriverList } from '../../../../model/document.driver.list';
import { compressImage } from '../../../../shared/utils/image-compression.util';
import { isAllowedUploadType } from '../../../../shared/utils/file-type-validator.util';

@Component({
  selector: 'app-detail-driver',
  standalone: true,
  imports: [
    ButtonModule,
    InputTextModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    FileUploadModule,
    ImageModule,
    DropdownModule,
    DialogModule,
    TabViewModule,
    DataViewModule,
  ],
  templateUrl: './detail-driver.component.html',
  styleUrl: './detail-driver.component.css',
})
export class DetailDriverComponent implements OnInit {
  @Input('iddriver') idDriver!: number;
  driverInfo!: DriverModel;
  newFile: boolean = false;
  ltsDocument: DocumentDriverModel[] = [];
  ltsTypeDocument: any[] = [];
  selectedTypeDocument: any | undefined;
  url_photo_driver: string = '';
  url_photo_vehicle: string = '';

  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
  ) {}

  ngOnInit(): void {
    this.getDriver();
    this.getLtsTypeDocument();
  }

  getLtsTypeDocument(): void {
    const body: JsonRequest = {
      data: JSON.stringify({
        typ_type_document: '1',
      }),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.apiService.consumirWSPost(
      properties.serviceGetAllTypeDocument,
      body,
      (data) => {
        this.ltsTypeDocument = data.data;
        this.selectedTypeDocument = this.ltsTypeDocument[0];
      },
    );
  }

  getDriver(): void {
    const body: JsonRequest = {
      data: JSON.stringify({
        dri_id: this.idDriver,
      }),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.apiService.consumirWSPost(
      properties.serviceGetDriver,
      body,
      (data) => {
        this.driverInfo = data.data;
        const docPhotoDriver: DocumentDriverList | undefined =
          this.driverInfo.lstDocument.find(
            (doc: DocumentDriverList) => doc.dri_doc_typ_codigo === 1,
          );
        if (docPhotoDriver) {
          this.url_photo_driver = docPhotoDriver.doc_route;
        }
      },
    );
  }

  downloadFile(url: string, fileName: string) {
    this.apiService.downloadFile(url).subscribe((blob) => {
      const link = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    });
  }
  deleteFile(document: any) {
    this.util
      .mostrarConfirmacion('Está seguro que desea borrar el registro?', 1)
      .then((accept) => {
        const body: JsonRequest = {
          data: JSON.stringify([
            {
              dri_doc_dri_id: document.dri_doc_dri_id,
              dri_doc_doc_id: document.dri_doc_doc_id,
              dri_doc_company: this.util.returnEmpresa(),
            },
          ]),
          company: this.util.returnEmpresa(),
          fecha: new Date(),
        };
        this.apiService.consumirWSPost(
          properties.serviceDeleteFileDriver,
          body,
          (data) => {
            if (data.estado === properties.codeOK) {
              this.util.mostrarToast(
                'Eliminación',
                'Se ha eliminado el documento',
                2,
              );
              this.getDriver();
            } else {
              this.util.mostrarToast('Eliminación', 'Error al Eliminar', 4);
            }
          },
        );
      });
  }

  dialogNewFile() {
    this.newFile = true;
  }

  async onUploadAuto(files: File[], fileUpload: any) {
    if (!isAllowedUploadType(files[0], true)) {
      this.util.mostrarToast(
        'Detalle Conductor',
        'Formato no permitido. Solo se aceptan imágenes PNG o JPG o documentos PDF.',
        4,
      );
      fileUpload.clear();
      return;
    }
    this.ltsDocument = [];
    const doc = await compressImage(files[0]);
    const filestring = await this.previewFile(doc);
    this.ltsDocument.push({
      dri_doc_dri_id: 0,
      dri_doc_doc_id: 0,
      dri_doc_company: this.util.returnEmpresa(),
      dri_doc_typ_codigo: this.selectedTypeDocument.typ_id,
      file: doc,
      filstring: filestring,
      typeDocument: this.selectedTypeDocument,
    });
    fileUpload.clear();
  }

  previewFile(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result) {
          resolve(reader.result as string);
        } else {
          reject('Error al leer el archivo');
        }
      };
      reader.onerror = () => {};
    });
  }

  remeveFile(index: number) {
    this.ltsDocument.splice(index, 1);
  }
  saveFile() {
    const formData = new FormData();
    this.ltsDocument.forEach((doc, index) => {
      formData.append(
        `lista[${index}][dri_doc_dri_id]`,
        this.driverInfo.dri_id.toString(),
      );
      formData.append(
        `lista[${index}][dri_doc_company]`,
        this.util.returnEmpresa().toString(),
      );
      formData.append(
        `lista[${index}][dri_doc_typ_codigo]`,
        doc.dri_doc_typ_codigo.toString(),
      );
      formData.append(`lista[${index}].file`, doc.file, doc.file.name);
    });
    this.apiService.consumirWSFilePost(
      properties.serviceFilesDriver,
      formData,
      (resp) => {
        if (resp.estado === properties.codeOK) {
          this.util.mostrarToast('Crear Archivo', 'Se ha creado el Archivo', 1);
          this.getDriver();
          this.closeNewFile();
        } else {
          this.util.mostrarToast('Crear Archivo', 'Error al crear', 4);
        }
      },
    );
  }

  closeNewFile() {
    this.ltsDocument = [];
    this.newFile = false;
  }
}
